import { useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { useAuth } from "../auth/AuthProvider";

export function OfficeMessagingSettings() {
  const { isAdmin, isSuperAdmin } = useAuth();
  const [settings, setSettings] = useState({ enabled: false, copyPrincipal: false, emailNotificationsEnabled: false, principalUid: "" });
  const [candidates, setCandidates] = useState<{ uid: string; label: string }[]>([]);
  const [counts, setCounts] = useState({ officeCount: 0, principalCount: 0 });
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState("");
  useEffect(() => {
    if (!isAdmin && !isSuperAdmin) return;
    let live = true;
    httpsCallable(functions, "getOfficeMessagingSettings")({}).then((r: any) => {
      if (!live) return;
      setSettings({ enabled: r.data.enabled, copyPrincipal: r.data.copyPrincipal, emailNotificationsEnabled: r.data.emailNotificationsEnabled, principalUid: r.data.principalUid || "" });
      setCandidates(r.data.principalCandidates || []);
      setCounts(r.data); setLoaded(true);
    }).catch(e => { if (live) setStatus(e.message); });
    return () => { live = false; };
  }, [isAdmin, isSuperAdmin]);
  if (!isAdmin && !isSuperAdmin) return null;
  return <div className="card section-card">
    <div className="section-eyebrow">Messaging</div><h3>School Office Inbox</h3>
    <p>All parents with a linked child can contact School Office. Current Office role users share access to all office conversations. Replies appear to parents as School Office.</p>
    <div style={{ display: "grid", gap: 14 }}>
      <label><input type="checkbox" disabled={!loaded || saving} checked={settings.enabled} onChange={e => setSettings({ ...settings, enabled: e.target.checked })} /> Allow parents to message School Office</label>
      <label><input type="checkbox" disabled={!loaded || saving || !settings.enabled} checked={settings.copyPrincipal} onChange={e => setSettings({ ...settings, copyPrincipal: e.target.checked })} /> Copy principal on office conversations</label>
      <label>Principal account <select className="input" disabled={!loaded || saving} value={settings.principalUid} onChange={e => setSettings({ ...settings, principalUid: e.target.value })}>
        <option value="">Use Principal special assignment</option>{candidates.map(c => <option key={c.uid} value={c.uid}>{c.label}</option>)}
      </select></label>
      <div className="muted">The selected principal can read existing office conversations and reply as School Office when copying is enabled. Turning copying off removes copied inbox access.</div>
      <label><input type="checkbox" disabled={!loaded || saving || !settings.enabled} checked={settings.emailNotificationsEnabled} onChange={e => setSettings({ ...settings, emailNotificationsEnabled: e.target.checked })} /> Email notifications to each Office role user's account email</label>
      <div className="muted">Browser push uses each user's existing notification permission. Email notifications are sent separately to each recipient. Disabling office messaging stops new conversations; existing conversations remain available.</div>
      {loaded && <div className="muted">Active office accounts: {counts.officeCount}. Currently copied principal accounts: {counts.principalCount}.</div>}
      <button className="btn" disabled={!loaded || saving} onClick={async () => {
        setSaving(true); setStatus("");
        try {
          await httpsCallable(functions, "saveOfficeMessagingSettings")(settings);
          const result: any = await httpsCallable(functions, "getOfficeMessagingSettings")({});
          setCounts(result.data); setStatus("School Office settings saved.");
        } catch (e: any) { setStatus(e.message || "Unable to save settings."); }
        finally { setSaving(false); }
      }}>{saving ? "Saving…" : "Save School Office Settings"}</button>
      {status && <div role="status">{status}</div>}
    </div>
  </div>;
}
